// extracted by mini-css-extract-plugin
export default {"container":"SG","promoapplied":"TG","tobeapplied":"UG","hr":"VG","teal":"WG","promoappliedcontainer":"XG","error":"YG","input":"ZG","errorInput":"aH","promo_x":"bH","promo_info":"cH","promoxcontainer":"eH"};
    if(module.hot) {
      // 1713912566105
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  